import { OverTimeInput, SubmitOverTimeInput } from './interface';

export class GetAllRequests {
    static readonly type = '[OverTime] all';
    constructor(
        public queryParams?: {
            formTitle?: string;
        }
    ) {}
}

export class CreateOverTime {
    static readonly type = '[OverTime] create ';
    constructor(public input: OverTimeInput) {}
}

export class SubmitOverTime {
    static readonly type = '[OverTime] submit ';
    constructor(public input: SubmitOverTimeInput) {}
}

export class GetSingleOverTime {
    static readonly type = '[OverTime] get-one';
    constructor(public id: string) {}
}
export class GetOverTimeByUser {
    static readonly type = '[OverTime] get-by-user';
    constructor(public input: { id: string; query: string }) {}
}
export class GetOverTimeByApprovers {
    static readonly type = '[OverTime] approvers';
    constructor(public input: { id: string; query: string }) {}
}

export class DeleteOverTime {
    static readonly type = '[OverTime] delete';
    constructor(public id: string) {}
}
export class ClearOverTime {
    static readonly type = '[OverTime] Clear ';
}
export class DeleteOverReq {
    static readonly type = '[Requests] get-approver';
    constructor(public id: string) {}
}
